module.exports = __webpack_public_path__ + "static/media/cdclogo.4956d308.jpeg";